import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { Cms} from '@impact/data';
import { StyleBreakpoints } from '../../../models/style-breakpoints';
import { IImageBreakpoints } from '../../../utils/responsive-image.component';

@Component({
    selector: 'app-grid-spot-item',
    template: `
        <ng-container *ngIf="imageAsBackground else showNestedContainer;">
            <div [ngClass]="{
                'grid-spot-item': true,
                'has-background-color': backgroundColor,
                'image-fills-column': imageAsBackground
                }">
                <div class="grid-spot-item__content" [ngStyle]="{'background-color':backgroundColor}">
                    <div class="grid-spot__image-wrapper" *ngIf="itemUrl">
                        <a [href]="itemUrl">
                            <app-responsive-image *ngIf="image && image?.src" [image]="image" [breakpoints]="imageBreakpoints"></app-responsive-image>
                            <app-rich-text *ngIf="textContent" class="grid-spot-item__text" [html]="textContent"></app-rich-text>
                        </a>
                    </div>
                    <div class="grid-spot__image-wrapper" *ngIf="!itemUrl">
                        <app-responsive-image *ngIf="image && image?.src" [image]="image" [breakpoints]="imageBreakpoints"></app-responsive-image>
                        <app-rich-text *ngIf="textContent" class="grid-spot-item__text" [html]="textContent"></app-rich-text>
                    </div>
                </div>
            </div>
        </ng-container>
        <ng-template #showNestedContainer>
            <div [ngClass]="{
                'grid-spot-item': true,
                'has-background-color': backgroundColor,
                'image-fills-column': imageAsBackground
                }">
                <div class="grid-spot-item__content" [ngStyle]="{'background-color':backgroundColor}">
                    <div *ngIf="image && image.src" class="grid-spot__image-wrapper">
                        <app-responsive-image *ngIf="image" [image]="image" [breakpoints]="imageBreakpoints"></app-responsive-image>
                    </div>
                    <app-rich-text *ngIf="textContent" class="grid-spot-item__text" [html]="textContent"></app-rich-text>
                </div>
            </div>
        </ng-template>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class GridSpotItemComponent implements OnInit {
    static ref = 'headlineandtextspot';

    @Input() image?: Cms.Media;
    @Input() textContent?: string;
    @Input() backgroundColor?: string;
    @Input() imageAsBackground?: boolean;
    @Input() itemUrl?: string;

    @Input() columns?: number | undefined;

    @Input() data: Cms.GridSpot;


    imageBreakpoints: IImageBreakpoints[];

    ngOnInit() {
        this.imageBreakpoints = [
            {
                breakpoint: StyleBreakpoints.Implicit,
                width: 360,
                mode: 'min'
            },
            {
                breakpoint: StyleBreakpoints.Xsmall,
                width: 460,
                mode: 'min'
            },
            {
                breakpoint: StyleBreakpoints.Small,
                width: 700,
                mode: 'min'
            },
            {
                breakpoint: StyleBreakpoints.Medium,
                width: this.getSize(),
                mode: 'min'
            }
        ];
    }

    getSize() {
        let size = 387;

        switch (this.columns) {
            case 1:
                size = size * 3;
                break;
            case 2:
                size = size * 2;
                break;
        }

        return Math.ceil(size);
    }

}
